import React, { useState } from 'react';
import { Form, Input, message, Modal, Spin, Descriptions, Tag, Statistic } from 'antd';
import { executeKnowledgeTest, KnowledgeTestRecordVo } from '@/api/knowledgeBase';

export interface TestQueryProp {
  kbId: number;
  updateFn: () => void;
  onCancel: () => void;
}

const TestQueryModal = ({ kbId, updateFn, onCancel }: TestQueryProp) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<KnowledgeTestRecordVo>();

  const onFinish = () => {
    form.validateFields().then(values => {
      setLoading(true);
      executeKnowledgeTest({ kbId, query: values.query })
        .then(res => {
          setResult(res);
          message.success('测试完成');
          updateFn();
        })
        .finally(() => setLoading(false));
    });
  };

  return (
    <Modal
      title="测试查询"
      open={true}
      onCancel={onCancel}
      onOk={onFinish}
      okText="测试"
      maskClosable={false}
      width={700}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="query" label="测试查询" rules={[{ required: true, message: '请输入测试查询内容' }]}>
          <Input.TextArea rows={3} placeholder="请输入测试查询内容" />
        </Form.Item>
      </Form>
      {result && (
        <div style={{ marginTop: 16, padding: 16, backgroundColor: '#f5f5f5', borderRadius: 4 }}>
          <Descriptions column={1} size="small" title="测试结果">
            <Descriptions.Item label="相关性评分">
              <Statistic value={result.relevanceScore || 0} suffix="/ 1.0" precision={2} />
            </Descriptions.Item>
          </Descriptions>
          {result.retrievedChunks && (
            <div style={{ marginTop: 8 }}>
              <strong>检索到的分块：</strong>
              <div style={{ maxHeight: 200, overflow: 'auto', marginTop: 8 }}>
                {result.retrievedChunks}
              </div>
            </div>
          )}
        </div>
      )}
    </Modal>
  );
};

export default TestQueryModal;